import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { TextField, Grid, makeStyles } from "@material-ui/core";
import { setZipCode, closeZipModal, showSnackbar } from "../../actions";
import { getZip } from "../../reducers/itemsReducer";
import SkiptiButton from "../skipti/Button";

const useStyles = makeStyles({
  // root: {
  //   "& .MuiInputLabel-shrink, & fieldset": {
  //     top: "0px !important",
  //   },
  // },

  // outlined: {
  //   top: "-8px",
  // },

  // shrink: {
  //  ,
  // },
});

function ChangeZip(props) {
  const {
    className,
    style,
    withSubmitButton,
    inputProps,
    fullWidth,
    InputLabelProps,
    outlined,
    margin,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const zipCode = useSelector(getZip);

  const formik = useFormik({
    initialValues: {
      zipModal: zipCode && zipCode !== "00000" ? zipCode : "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      const maxFiveNumbers = new RegExp(/^[0-9]{5}$/);
      if (maxFiveNumbers.test(values.zipModal)) {
        dispatch(setZipCode(values.zipModal, true));
        dispatch(closeZipModal());
      } else {
        dispatch(showSnackbar("You added an invalid Zip Code!", "error"));
      }
    },
  });

  useEffect(() => {
    if (zipCode && zipCode !== "00000") {
      formik.setFieldValue("zipModal", zipCode);
    } else {
      formik.setFieldValue("zipModal", "");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zipCode]);

  const handleZipChange = (event) => {
    dispatch(setZipCode(event.target.value, true));
    dispatch(closeZipModal());
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={1} justifyContent="center" alignItems="center">
        <Grid item xs={withSubmitButton ? 12 : 12}>
          <TextField
            fullWidth={fullWidth || !!withSubmitButton}
            id="zipModal"
            name="zipModal"
            label="Zip Code"
            FormHelperTextProps={{ error: true }}
            variant={outlined ? "outlined" : "standard"}
            margin={margin || "normal"}
            autoComplete="off"
            style={style}
            className={className}
            classes={classes}
            InputProps={inputProps}
            InputLabelProps={{
              ...InputLabelProps,
              classes,
            }}
            value={formik.values.zipModal}
            onChange={(event) => {
              if (!withSubmitButton) {
                const maxFiveNumbers = new RegExp(/^[0-9]{5}$/);
                if (maxFiveNumbers.test(event.target.value)) {
                  handleZipChange(event);
                }

                formik.setFieldError(
                  "zipModal",
                  "Zip code must contain exactly 5 digits"
                );
              }
              formik.setFieldValue("zipModal", event.target.value);
              if (!formik.touched.zipModal) {
                formik.setFieldTouched("zipModal", true);
              }
            }}
            error={!!formik.touched.zipModal && !!formik.errors.zipModal}
            helperText={
              !!formik.touched.zipModal &&
              !!formik.errors.zipModal &&
              formik.errors.zipModal
            }
          />
        </Grid>
        {withSubmitButton && (
          <Grid item xs={withSubmitButton ? 12 : 4}>
            <div className="tw-flex tw-justify-center">
              <SkiptiButton
                primary
                type="submit"
                // disabled={isSubmitting || this.props.isLoading || isError}
              >
                Submit
              </SkiptiButton>
            </div>
          </Grid>
        )}
      </Grid>
    </form>
  );
}

export default ChangeZip;
